// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class LibraryCardCheckoutListController {
   $filter: any
   $log: any
   $q: any
   $scope: any
   alerts: any
   allSelected: any
   apiService: any
   docs: any
   emptyListMessage: any
   error: any
   i18n: any
   isLoading: any
   listLoadError: any
   rawBibIds: any
   selectedCount: any
   sierraService: any
   sierraBibRequestDoc: any
   sortOptionSelected: any
   sortOptions: any
   success: any
   libraryCardErrorHelper: any
   constructor($scope: any, sierraService: any, apiService: any, translationService: any, alertService: any, $q: any, $log: any, $filter: any, $rootScope: any, $authEvents: any, libraryCardErrorHelper: any) {
      this.$onInit = this.$onInit.bind(this)
      this.$onChanges = this.$onChanges.bind(this)
      this.loadCheckouts = this.loadCheckouts.bind(this)
      this.updateSelected = this.updateSelected.bind(this)
      this.toggle = this.toggle.bind(this)
      this.renewCheckout = this.renewCheckout.bind(this)
      this.renewSelectedCheckouts = this.renewSelectedCheckouts.bind(this)
      this.$scope = $scope
      this.sierraService = sierraService
      this.apiService = apiService
      this.$q = $q
      this.$log = $log
      this.$filter = $filter
      this.i18n = translationService
      this.isLoading = false
      this.docs = []
      this.rawBibIds = []
      this.sierraBibRequestDoc = []
      this.selectedCount = 0
      this.allSelected = false
      this.sortOptions = [ 
         { sortBy: 'dueBy', translation: translationService.translations.DUE_DATE, dateOrCode: true},
         { sortBy: 'checkoutDate', translation: translationService.translations.CHECK_OUT_DATE, dateOrCode: true },
         { sortBy: 'author', translation: translationService.translations.AUTHOR, dateOrCode: false },
         { sortBy: 'title', translation: translationService.translations.TITLE, dateOrCode: true }
      ]
      this.sortOptionSelected = { sortBy: '', translation: '', dateOrCode: false }
      this.alerts = alertService
      this.libraryCardErrorHelper = libraryCardErrorHelper

      $rootScope.$on($authEvents.LOGOUTSUCCESS, () => this.docs = [])
   }

   $onInit() {
      this.loadCheckoutsWhenReady()      
   }

   $onChanges(changesObj: any) {
      if (changesObj.reloadTrigger.currentValue) {
         return this.loadCheckoutsWhenReady()
      }
   }

   loadCheckoutsWhenReady(){
      this.isLoading = true
      return this.sierraService.patronInfoLoadedPromise.promise
         .then(() => this.loadCheckouts())
         .catch((err: any) => this.handleError(err))
   }

   loadCheckouts(prevActionSuccessMessage = '', prevActionErrorMessage = '') {
      this.listLoadError = false
      this.isLoading = true
      this.sierraService
         .getCheckouts()
         .then((resp: any) => {
            this.rawBibIds = _.chain(resp.data.entries)
               .map((ent: any) => ({
                  itemId: ent.item.id,
                  bibId: ent.item.bibIds ? ent.item.bibIds[0] : ent.item.id,
                  dueDate: ent.dueDate,
                  checkoutId: ent.id,
                  outDate: ent.outDate,
                  barcode: ent.item.barcode,
                  // callNumber not always present
                  callNumber: ent.item.callNumber ? ent.item.callNumber : ''
               }))
               .value()

            const apiQuery = this.sierraService.createApiQuery(this.rawBibIds)
            if (apiQuery) {
               return this.apiService.get('search', apiQuery, {avoidUpdateFire: true})
            }
            return this.$q.resolve()
         }).then((resp: any) => {
            if (resp && resp.data) {
               const promiseList = _.map(this.rawBibIds, (sierraRequestDoc: any) => {
                  const doc = this.sierraService.findDocIfExists(resp.data.documents, sierraRequestDoc.bibId)
                  if(sierraRequestDoc.itemId.includes("@ill")){
                     return this.sierraService.getItemByBibId(sierraRequestDoc.itemId)
                        .then((resp: any) => {
                           this.sierraBibRequestDoc = resp.data
                           return this.parseDocDetails(sierraRequestDoc, doc, this.sierraBibRequestDoc)
                        }).catch((err: any) => {
                           return this.handleError(err)
                        })       
                  } else { 
                     return this.$q.resolve(this.parseDocDetails(sierraRequestDoc,doc))                
                  }
               })
               return Promise.all(promiseList)
            } else {
               return this.$q.resolve([]) 
            }
         }).then((docs: any[]) => {
            this.docs = docs
            if (this.docs.length === 0) {
               this.emptyListMessage = this.i18n.translations.CHECKED_OUT_EMPTY
            } else {
               this.sortList()
            }
            if (prevActionSuccessMessage) {
               this.success = prevActionSuccessMessage
               this.alerts.pulseAlert('libraryCardSuccess', this.success, 5000)
            }
            if (prevActionErrorMessage) {
               this.error = prevActionErrorMessage
               this.alerts.pulseAlert('libraryCardError', this.error, 10000)
            }
            this.isLoading = false
            return this.updateSelected()
         }).catch((err: any) => {
            return this.handleError(err)
         })
   }

   parseDocDetails(sierraRequestDoc: any, searchApiDoc: any, sierraBibRequestDoc?: any){
      const calculateDays = function(dateString: any) {
         const today = new Date()
         const dueDate = new Date(dateString)
         // @ts-expect-error TS(2362) FIXME: The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
         return Math.round((dueDate - today)/(1000*60*60*24))
      }
      if (!searchApiDoc) {                        
         searchApiDoc = this.sierraService.createDummyDoc(this.i18n.translations.NO_RESOURCE_FOUND)
      }

      const dueBy = sierraRequestDoc.dueDate
      const daysLeft = calculateDays(sierraRequestDoc.dueDate)
      const isOverdue = daysLeft < 0
      const checkoutId = this.sierraService.getIdFromUrlString(sierraRequestDoc.checkoutId)
      const {
         bibId
      } = sierraRequestDoc
      const checkoutDate = sierraRequestDoc.outDate
      const barcode = sierraRequestDoc.barcode
      const callNumber = sierraRequestDoc.callNumber
      if(sierraBibRequestDoc){
         const author = sierraBibRequestDoc.author?.length ? sierraBibRequestDoc.author : undefined
         const {
            title
         } = sierraBibRequestDoc
         searchApiDoc.full_title = title
         searchApiDoc.authors = [{fullname: author}]
         delete searchApiDoc.missingDocDisplay
         return { doc: {...searchApiDoc, ...sierraBibRequestDoc }, dueBy, daysLeft, checkoutId, bibId, checkoutDate, author, title, isOverdue, barcode, callNumber }
      } else {
         const author = searchApiDoc.authors?.length ? searchApiDoc.authors[0].fullname : undefined
         const {
            title
         } = searchApiDoc
         return { doc: searchApiDoc, dueBy, daysLeft, checkoutId, bibId, checkoutDate, author, title, isOverdue, barcode, callNumber }
      }      
   }

   handleError(err: any) {
      this.$log.error(err)
      this.isLoading = false
      this.listLoadError = true
      const errorMessage = this.libraryCardErrorHelper.getLibraryCardErrorMessage(err, this.sierraService, this.i18n)
      this.error = this.i18n.translate(this.i18n.translations.CHECKED_OUT_ERROR, {error: errorMessage})
      return this.alerts.setAlert('libraryCardListLoadError', this.error)
   }

   sortList(sortOption = this.sortOptions[0]) {
      this.sortOptionSelected = sortOption
      return this.docs = sortOption.dateOrCode ? this.$filter('orderBy')(this.docs, sortOption.sortBy) : this.$filter('localeSort')(this.docs, sortOption.sortBy)
   }

   getSortByOption() {
      return this.sortOptionSelected.translation
   }

   updateSelected() {
      this.selectedCount = _.filter(this.docs, (doc: any) => doc.selected).length
      return this.allSelected = this.selectedCount === this.docs.length
   }

   toggle(doc: any) {
      _.each(this.docs, (doc: any) => { return doc.selected = this.allSelected })
      return this.updateSelected()
   }

   renewCheckout(id: any) {
      this.success = ''
      this.error = ''
      this.isLoading = true
      const idx = _.findIndex(this.docs, (doc: any) => doc.checkoutId === id)
      return this.sierraService.renewCheckout(id)
         .then((data: any) => {
            this.$log.debug(' loan succesfully renewed ')
            return this.loadCheckouts(this.i18n.translations.CHECKED_OUT_RENEWAL_SUCCESS)
         }).catch((err: any) => {
            this.$log.error('error renewing loan ', err)
            this.isLoading = false
            window.scrollTo(0,0)
            if (err.status === 403) {
               if (err.data?.description) { 
                  this.error = this.i18n.translate(this.i18n.translations.CHECKED_OUT_RENEWAL_ERROR_X, {error:  err.data.description.replace(/WebPAC Error\s?:?\s?/i, '') })
               } else {
                  this.error = this.i18n.translations.CHECKED_OUT_RENEWAL_ERROR_403 
               }
            } else {
               this.error = this.i18n.translations.CHECKED_OUT_RENEWAL_ERROR
            }
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }

   renewSelectedCheckouts() {
      this.success = ''
      this.error = ''
      this.isLoading = true
      const selectedDocs = _.filter(this.docs, (doc: any) => doc.selected)
      const renewPromises = _.map(selectedDocs, (doc: any) => {
         return this.sierraService.createAlwaysSuccessPromise(this.sierraService.renewCheckout(doc.checkoutId), doc.checkoutId)
      })

      const handleResults = (results: any) => { 
         this.isLoading = false
         const successDocs: any = []
         const failedDocsWithError = []
         _.map(results, (result: any) => { 
            if (result.status === 'success') {
               return successDocs.push(result.checkoutId)
            } else {
               return failedDocsWithError.push({checkoutId: result.checkoutId, error: result.original})
            }
         })

         if (successDocs.length === selectedDocs.length) { // All success, reload checkouts with success message
            return this.loadCheckouts(this.i18n.translations.CHECKED_OUT_RENEWAL_SUCCESS_ALL)
         } else if (failedDocsWithError.length && !successDocs.Length) { // All failure, show failure message without reloading checkouts
            this.error = this.i18n.translate(this.i18n.translations.CHECKED_OUT_RENEWAL_SOME_ERROR, {number: failedDocsWithError.length})
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         } else if (!failedDocsWithError.length && successDocs.Length) { // Some Success and some failure, reload checkouts with failure message
            return this.loadCheckouts('', this.i18n.translate(this.i18n.translations.CHECKED_OUT_RENEWAL_SOME_ERROR, {number: failedDocsWithError.length}))
         }
      }

      return this.$q
         .all(renewPromises) 
         .then(handleResults) 
         .catch((errors: any) => {
            this.error = this.i18n.translations.CHECKED_OUT_RENEWAL_ERROR
            return this.alerts.pulseAlert('libraryCardError', this.error, 10000)
         })
   }
}

LibraryCardCheckoutListController.$inject = ['$scope', 'sierraService', 'apiService', 'translationService', 'alertService', '$q', '$log', '$filter', '$rootScope', '$authEvents', 'libraryCardErrorHelper']

angular.module('summonApp.controllers')
   .controller('libraryCardCheckoutListController', LibraryCardCheckoutListController)
